import { Clock, IndianRupee, MapPin, Stethoscope } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { MapEmbed } from "@/components/common/MapEmbed";
import { HoursList } from "@/components/common/HoursList";
import { CallButton, WhatsAppButton } from "@/components/common/ContactButtons";
import { inr } from "@/lib/format";
import { accent } from "@/lib/ui";

const Item = ({ icon: Icon, title, tone, children }) => (
  <div className="flex gap-4">
    <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl shadow-md ${tone}`}>
      <Icon className="h-5 w-5" aria-hidden="true" />
    </span>
    <div>
      <p className="text-sm font-semibold uppercase tracking-wider text-brand-blue">{title}</p>
      <div className="mt-1 text-base text-slate-700">{children}</div>
    </div>
  </div>
);

export const ClinicDetails = ({ testid = "clinic-details" }) => {
  const { settings } = useSite();
  return (
    <div className="space-y-6" data-testid={testid}>
      <Item icon={MapPin} title="Address" tone={accent(0).icon}>{settings.address}</Item>
      <Item icon={Clock} title="Clinic hours" tone={accent(1).icon}><HoursList /></Item>
      <Item icon={IndianRupee} title="Consultation fee" tone={accent(2).icon}>{inr(settings.consultation_fee)} per visit</Item>
      <Item icon={Stethoscope} title="Appointments" tone={accent(3).icon}>In person only, by prior appointment</Item>
    </div>
  );
};

export const VisitClinic = () => (
  <section className="section relative overflow-hidden bg-gradient-to-br from-white via-brand-skyTint/50 to-brand-greenTint" aria-labelledby="visit-heading">
    <div className="container-x grid gap-10 lg:grid-cols-2 lg:gap-16">
      <div>
        <p className="eyebrow">Visit the clinic</p>
        <h2 id="visit-heading" className="font-heading text-2xl font-bold tracking-tight text-brand-ink sm:text-3xl lg:text-4xl">Find us in Mohali</h2>
        <p className="mt-4 text-base text-slate-600 md:text-lg">Easy to reach from Mohali, Chandigarh and Panchkula.</p>
        <div className="mt-8"><ClinicDetails testid="home-clinic-details" /></div>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <CallButton testid="visit-call-btn" />
          <WhatsAppButton testid="visit-whatsapp-btn" />
        </div>
      </div>
      <MapEmbed />
    </div>
  </section>
);
